<template>
  <span
    class="app-tooltip"
    :class="[`app-tooltip--${position}`]"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave">
    <span
      class="app-tooltip__trigger"
      tabindex="0"
      @focus="onMouseEnter"
      @blur="onMouseLeave">
      <slot></slot>
    </span>

    <transition name="app-tooltip-fade">
      <span
        v-if="visible && !disabled"
        class="app-tooltip__bubble"
        role="tooltip"
        :aria-hidden="visible ? 'false' : 'true'"
        :style="bubbleStyle">
        <slot name="content">{{ content }}</slot>
      </span>
    </transition>
  </span>
</template>

<script>
export default {
  name: 'AppTooltip',
  props: {
    content: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      default: 'top',
      validator: value => ['top', 'bottom', 'left', 'right'].includes(value)
    },
    disabled: {
      type: Boolean,
      default: false
    },
    delay: {
      type: Number,
      default: 150
    },
    maxWidth: {
      type: String,
      default: '220px'
    }
  },
  data () {
    return {
      visible: false,
      timer: null
    }
  },
  computed: {
    bubbleStyle () {
      return { maxWidth: this.maxWidth }
    }
  },
  methods: {
    onMouseEnter () {
      if (this.disabled) return
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.visible = true
      }, this.delay)
    },
    onMouseLeave () {
      clearTimeout(this.timer)
      this.visible = false
    }
  },
  destroyed () {
    clearTimeout(this.timer)
  }
}
</script>

<style scoped>
.app-tooltip {
  position: relative;
  display: inline-flex;
}

.app-tooltip__trigger {
  display: inline-flex;
  outline: none;
}

.app-tooltip__bubble {
  position: absolute;
  z-index: 1070;
  width: max-content;
  max-width: 220px;
  padding: 0.375rem 0.625rem;
  border-radius: var(--app-border-radius, 5px);
  background-color: var(--app-primary, #0f2835);
  color: #fff;
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.4;
  text-align: center;
  pointer-events: none;
  box-shadow: var(--app-shadow-md, 0 4px 6px -1px rgba(0, 0, 0, 0.1));
}

/* Posición: top */
.app-tooltip--top .app-tooltip__bubble {
  bottom: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
}

.app-tooltip--top .app-tooltip__bubble::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: var(--app-primary, #0f2835);
}

/* Posición: bottom */
.app-tooltip--bottom .app-tooltip__bubble {
  top: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
}

.app-tooltip--bottom .app-tooltip__bubble::after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-bottom-color: var(--app-primary, #0f2835);
}

/* Posición: left */
.app-tooltip--left .app-tooltip__bubble {
  right: calc(100% + 6px);
  top: 50%;
  transform: translateY(-50%);
}

.app-tooltip--left .app-tooltip__bubble::after {
  content: '';
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  border: 5px solid transparent;
  border-left-color: var(--app-primary, #0f2835);
}

/* Posición: right */
.app-tooltip--right .app-tooltip__bubble {
  left: calc(100% + 6px);
  top: 50%;
  transform: translateY(-50%);
}

.app-tooltip--right .app-tooltip__bubble::after {
  content: '';
  position: absolute;
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
  border: 5px solid transparent;
  border-right-color: var(--app-primary, #0f2835);
}

/* Transición */
.app-tooltip-fade-enter-active,
.app-tooltip-fade-leave-active {
  transition: opacity 0.15s ease;
}

.app-tooltip-fade-enter,
.app-tooltip-fade-leave-to {
  opacity: 0;
}
</style>
